import { render, staticRenderFns } from "./average.vue?vue&type=template&id=40b73f53"
import script from "./average.vue?vue&type=script&lang=js"
export * from "./average.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40b73f53')) {
      api.createRecord('40b73f53', component.options)
    } else {
      api.reload('40b73f53', component.options)
    }
    module.hot.accept("./average.vue?vue&type=template&id=40b73f53", function () {
      api.rerender('40b73f53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/report/orderTimeliness/average.vue"
export default component.exports